// =============================================================================
// FONT AWESOME CORE
// =============================================================================
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// =============================================================================
// FONT AWESOME ICONS
// =============================================================================
import {
    faServer as faServerSolid,
    faClockRotateLeft,
    faScissors,
    faGear as faSolidGear,
    faPhoneRotary,
    faCameraWeb,
    faMicrophone,
    faVideo as faVideoSolid,
    faStop,
    faCircleUser as faCircleUserSolid,
    faBellExclamation,
    faRotateExclamation,
    faEllipsisVertical,
    faMobile as faMobileSolid,
    faComputer as faComputerSolid,
    faFolder,
    faHeart as faHeartSolid,
    faChartLineUp,
    faPenToSquare as faPenToSquareSolid,
    faShuffle,
    faTrashUndo,
    faCircleQuestion as faCirclequestionSolid,
    faShare as faShareSolid,
    faX as faXSolid,
    faUsbDrive,
    faArrowLeftLongToLine,
    faArrowRightLongToLine,
    faFamily,
    faHouse as faHouseSolid,
    faCircle as faCircleSolid,
    faArrowDownToBracket as faSolidArrowDownToBracket,
    faRotate,
    faTrash,
    faImage,
    faCheck,
    faCircleCheck,
    faShareFromSquare,
    faRotateLeft,
    faRotateRight,
    faListMusic,
    faImages as faImagesSolid,
    faBolt as faBoltSolid,
    faTriangleExclamation as faTriangleExclamationSolid,
    faThumbsUp as faThumbsUpSolid,
    faMagnifyingGlass as faMagnifyingGlassSolid,
    faBadgeDollar as faBadgeDollarSolid,
    faCircleXmark as faCircleXmarkSolid,
    faSignalStream,
    faScreenUsers,
    faCloudMusic,
    faStore,
    faToolbox,
    faCameraMovie,
    faRepeat,
    faCalendarDay,
    faHandPointer,
    faBinoculars,
    faBadgeCheck,
    faStar,
    faCalendars,
    faInfinity,
    faUser,
    faArrowRight,
    faArrowDown as faArrowDownSolid,
    faArrowUp as faArrowUpSolid,
    faBars as faBarsSolid,
    faRightFromBracket,
    faArrowLeft,
    faPlay,
    faCloudArrowUp,
    faChartSimple,
    faPlus,
    faMinus,
    faCodeSimple,
    faChevronDown,
    faChevronUp,
    faChevronRight,
    faChevronsRight,
    faChevronLeft,
    faChevronsLeft,
    faPause,
    faPhone,
    faPhonePlus,
    faEllipsis,
    faShop,
    faLink,
    faPaperPlaneTop,
    faCompactDisc,
    faComputerClassic,
    faLocationDot,
    faPerson,
    faCalendarRange,
    faCalendarCircleUser,
    faLoader,
    faProjector,
    faChild,
    faPersonCane,
    faThoughtBubble,
    faTv,
    faFileMusic as faFileMusicSolid,
    faFileVideo as faFileVideoSolid,
    faImageSlash,
    faTimes,
    faDownload,
    faMusic as faMusicSolid,
    faCaretDown,
    faCaretUp,
    faClock as faClockSolid,
    faWandMagicSparkles as faWandMagicSparklesSolid,
    faCircleInfo as faCircleInfoSolid,
    faSlidersH,
    faPaintBrush,
    faMagicWandSparkles,
    faCircleExclamation as faCircleExclamationSolid,
    faMessage as faMessageSolid,
    faUsers as faUsersSolid,
    faHandshake as faHandshakeSolid,
    faBuilding as faBuildingSolid,
    faFilm as faFilmSolid,
    faFilmCanister,
    faListCheck as faListCheckSolid,
    faFloppyDisk as faFloppyDiskSolid,
    faMobileAlt,
    faCamera,
    faQrcode as faQrcodeSolid,
    faFileDownload,
    faUpload,
    faPalette,
    faExpand as faExpandSolid,
    faCompress as faCompressSolid,
    faPhotoFilmMusic as faPhotoFilmMusicSolid,
    faFileMov as faFileMovSolid,
    faClipboard,
    faFileAudio as faFileAudioSolid,
    faThumbtack,
    faSpinner as faSpinnerSolid,
} from '@fortawesome/pro-solid-svg-icons';
import {
    faBars as faBarsReg,
    faMessage as faMessageReg,
    faChevronRight as faChevronRightReg,
    faChevronDown as faChevronDownReg,
    faRabbitRunning as faRabbitRunningReg,
    faBarsStaggered,
    faUsers,
    faPipe,
    faTriangleExclamation as faTriangleExclamationReg,
    faArrowRotateLeft as faArrowRotateLeftReg,
    faRotate as faRotateReg,
    faTableLayout,
    faImageUser,
    faDatabase,
    faUser as faUserReg,
    faEllipsis as faEllipsisRegular,
    faCircleArrowRight,
    faEnvelopesBulk,
    faCircleInfo,
    faMagnifyingGlassPlus,
    faRabbitRunning,
    faFileVideo,
    faBullseyeArrow,
    faScaleBalanced,
    faListCheck,
    faChartSimple as faChartSimpleReg,
    faArrowDown as faArrowDownReg,
    faGaugeMax,
    faKey,
    faBackspace,
    faArrowUpWideShort,
    faCloudExclamation,
    faBroomWide,
    faCalendarCircleExclamation,
    faArrowDownShortWide,
    faShuffle as faShuffleReg,
    faShareFromSquare as faShareFromSquareReg,
    faPlus as faPlusReg,
    faCloudPlus,
    faCircleMinus,
    faCirclePlus,
    faImage as faImageReg,
    faRotateRight as faRotateRightReg,
    faRotateLeft as faRotateLeftReg,
    faHeart as faHeartReg,
    faCalendarClock,
    faCalendarDay as faCalendarDayReg,
    faFileArrowUp,
    faArrowLeft as faArrowLeftReg,
    faArrowRight as faArrowRightReg,
    faClapperboardPlay,
    faShare,
    faBackwardFast,
    faForwardFast,
    faPlayCircle,
    faCircle as faCircleReg,
    faGrid,
    faMobileNotch,
    faPrint,
    faCloudArrowUp as faCloudArrowUpReg,
    faPhotoFilmMusic,
    faMusic,
    faCirclePlay,
    faCirclePause,
    faCircleStop,
    faX,
    faArrowUp,
    faListDropdown,
    faTags,
    faCashRegister,
    faVolume,
    faVolumeXmark,
    faVolumeSlash as faVolumeSlashReg,
    faBoxOpen,
    faCartShopping,
    faCircleUser,
    faCircleQuestion,
    faCircleX,
    faThumbsUp,
    faHouse,
    faVideo,
    faServer,
    faBoxArchive,
    faSuitcase,
    faDollarSign,
    faDisplay,
    faGear,
    faArrowUpRightFromSquare,
    faArrowDownToBracket,
    faUserPlus,
    faUserGroup,
    faTrashCan,
    faClock,
    faFileLines,
    faMapLocation,
    faClone,
    faPencil,
    faArrowUpFromBracket,
    faArrowRightFromBracket,
    faTriangleExclamation,
    faEnvelope,
    faLock,
    faList,
    faBolt,
    faMagnifyingGlass,
    faBan,
    faEyeSlash,
    faEye,
    faPenToSquare,
    faCode,
    faCheck as faCheckReg,
    faCheckCircle,
    faWifiExclamation,
    faGraduationCap,
    faMobile,
    faCloud,
    faShield,
    faExpand,
    faCompress,
    faBadgeDollar,
    faImages,
    faTruckFast,
    faPalletBox,
    faMapLocationDot,
    faFileArrowDown,
    faUtilityPoleDouble,
    faFilm,
    faChevronLeft as faChevronLeftReg,
    faCircleNotch,
    faWrench,
    faChevronUp as faChevronUpReg,
    faPhotoVideo,
    faArrowDownToLine as faArrowDownToLineReg,
    faBookOpenCover as faBookOpenCoverReg,
    faQrcode,
    faSortCircle,
    faBringFront,
    faTimer,
    faGift,
} from '@fortawesome/pro-regular-svg-icons';
import { faCcStripe, faStripe, faFacebook, faFacebookSquare } from '@fortawesome/free-brands-svg-icons';
// =============================================================================
// FONT AWESOME REGISTER
// =============================================================================
library.add(
    faSpinnerSolid,
    faFileMovSolid,
    faRabbitRunningReg,
    faPhotoFilmMusicSolid,
    faTimer,
    faBringFront,
    faServerSolid,
    faComputerSolid,
    faExpandSolid,
    faCompressSolid,
    faVolumeSlashReg,
    faPalette,
    faQrcodeSolid,
    faFloppyDiskSolid,
    faListCheckSolid,
    faFilmSolid,
    faFilmCanister,
    faBuildingSolid,
    faHandshakeSolid,
    faUsersSolid,
    faBookOpenCoverReg,
    faArrowDownToLineReg,
    faMessageSolid,
    faMessageReg,
    faFacebookSquare,
    faCircleExclamationSolid,
    faCircleInfoSolid,
    faWandMagicSparklesSolid,
    faClockSolid,
    faBarsStaggered,
    faCaretDown,
    faCaretUp,
    faChevronUpReg,
    faUsers,
    faMusicSolid,
    faPipe,
    faTriangleExclamationReg,
    faWrench,
    faArrowRotateLeftReg,
    faRotateReg,
    faTableLayout,
    faCheckReg,
    faImageUser,
    faDatabase,
    faUserReg,
    faImageSlash,
    faEllipsisRegular,
    faFileMusicSolid,
    faFileVideoSolid,
    faCircleArrowRight,
    faEnvelopesBulk,
    faCircleInfo,
    faMagnifyingGlassPlus,
    faRabbitRunning,
    faFileVideo,
    faClockRotateLeft,
    faScissors,
    faTv,
    faSolidGear,
    faPhoneRotary,
    faThoughtBubble,
    faBullseyeArrow,
    faScaleBalanced,
    faListCheck,
    faCamera,
    faCameraWeb,
    faChevronLeftReg,
    faChevronRightReg,
    faChevronDownReg,
    faChartSimpleReg,
    faArrowDownReg,
    faGaugeMax,
    faMicrophone,
    faVideoSolid,
    faStop,
    faCircleUserSolid,
    faKey,
    faBackspace,
    faBellExclamation,
    faRotateExclamation,
    faArrowUpWideShort,
    faCloudExclamation,
    faBroomWide,
    faCalendarCircleExclamation,
    faArrowDownShortWide,
    faShuffleReg,
    faShareFromSquareReg,
    faPlusReg,
    faEllipsisVertical,
    faCalendarClock,
    faCloudPlus,
    faMobileSolid,
    faCircleMinus,
    faCirclePlus,
    faImageReg,
    faRotateRightReg,
    faRotateLeftReg,
    faFolder,
    faHeartReg,
    faHeartSolid,
    faFilm,
    faCalendarDayReg,
    faChartLineUp,
    faPenToSquareSolid,
    faShuffle,
    faFileArrowUp,
    faTrashUndo,
    faCirclequestionSolid,
    faArrowRightReg,
    faArrowLeftReg,
    faShareSolid,
    faCircleCheck,
    faXSolid,
    faUsbDrive,
    faArrowLeftLongToLine,
    faArrowRightLongToLine,
    faFamily,
    faHouseSolid,
    faClapperboardPlay,
    faShare,
    faForwardFast,
    faBackwardFast,
    faPlayCircle,
    faCircleSolid,
    faCircleReg,
    faGrid,
    faMobileNotch,
    faSolidArrowDownToBracket,
    faRotate,
    faTrash,
    faPrint,
    faCloudArrowUpReg,
    faImage,
    faCheck,
    faShareFromSquare,
    faRotateLeft,
    faRotateRight,
    faListMusic,
    faImagesSolid,
    faCircleXmarkSolid,
    faTriangleExclamationSolid,
    faMagnifyingGlassSolid,
    faThumbsUpSolid,
    faBadgeDollarSolid,
    faBoltSolid,
    faHandPointer,
    faPhotoFilmMusic,
    faMusic,
    faCirclePlay,
    faCirclePause,
    faCircleStop,
    faCloudMusic,
    faRepeat,
    faSignalStream,
    faCameraMovie,
    faCalendarDay,
    faScreenUsers,
    faToolbox,
    faStore,
    faX,
    faBinoculars,
    faBadgeCheck,
    faStar,
    faPersonCane,
    faChild,
    faCalendars,
    faInfinity,
    faProjector,
    faLoader,
    faArrowUp,
    faCalendarCircleUser,
    faCalendarRange,
    faPerson,
    faLocationDot,
    faArrowDownSolid,
    faArrowUpSolid,
    faComputerClassic,
    faCompactDisc,
    faStripe,
    faPaperPlaneTop,
    faListDropdown,
    faUtilityPoleDouble,
    faLink,
    faFileArrowDown,
    faMapLocationDot,
    faPalletBox,
    faTruckFast,
    faImages,
    faBadgeDollar,
    faTags,
    faCashRegister,
    faExpand,
    faCompress,
    faVolume,
    faVolumeXmark,
    faShop,
    faBoxOpen,
    faCheckCircle,
    faWifiExclamation,
    faGraduationCap,
    faShield,
    faCloud,
    faMobile,
    faMobileAlt,
    faEllipsis,
    faPhonePlus,
    faPhone,
    faMinus,
    faCartShopping,
    faCode,
    faPenToSquare,
    faEyeSlash,
    faEye,
    faPause,
    faChevronRight,
    faChevronsRight,
    faChevronLeft,
    faChevronsLeft,
    faBan,
    faMagnifyingGlass,
    faBolt,
    faList,
    faUser,
    faArrowRight,
    faCcStripe,
    faBarsReg,
    faBarsSolid,
    faHouse,
    faVideo,
    faServer,
    faBoxArchive,
    faChartSimple,
    faSuitcase,
    faDollarSign,
    faDisplay,
    faCircleUser,
    faGear,
    faRightFromBracket,
    faArrowLeft,
    faPlay,
    faCircleQuestion,
    faArrowUpRightFromSquare,
    faArrowUpFromBracket,
    faArrowRightFromBracket,
    faThumbsUp,
    faCloudArrowUp,
    faPlus,
    faUserPlus,
    faUserGroup,
    faTrashCan,
    faClock,
    faFileLines,
    faMapLocation,
    faClone,
    faCodeSimple,
    faPencil,
    faCircleX,
    faTriangleExclamation,
    faEnvelope,
    faLock,
    faChevronDown,
    faChevronUp,
    faArrowDownToBracket,
    faFacebook,
    faCircleNotch,
    faTimes,
    faDownload,
    faSlidersH,
    faPaintBrush,
    faMagicWandSparkles,
    faPhotoVideo,
    faQrcode,
    faFileDownload,
    faUpload,
    faSortCircle,
    faGift,
    faThumbtack,
    faClipboard,
    faFileAudioSolid,
);
export function setupFontAwesome(app) {
    app.component('FontAwesomeIcon', FontAwesomeIcon);
}
